import { render, staticRenderFns } from "./VehicleTag.vue?vue&type=template&id=6bae2608&"
import script from "./VehicleTag.vue?vue&type=script&lang=js&"
export * from "./VehicleTag.vue?vue&type=script&lang=js&"
import style0 from "./VehicleTag.vue?vue&type=style&index=0&id=6bae2608&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports